import React, { useContext } from 'react';
import { css } from '@emotion/react';
import t from 'react-translate';

import { black, warning, white } from 'styles/global_defaults/colors';
import { topHeaderHeight } from 'styles/global_defaults/scaffolding';

// hooks
import useCourseHomeUtils from 'shared/hooks/use-course-home-utils';
import { useLecturePageParams } from 'lecture_pages/hooks/lecture-routing';

// components
import { LecturePageMode } from 'lecture_pages/components';
import { linkTolecturePage } from 'lecture_pages/components/lecture-page-routes';
import { AngularServicesContext } from 'react-app';
import TopPanelActionButton from './top-panel-action-button';
import { config } from '../../../../../config/config.json';

const LecturePageEditButton = () => {
  const styles = css`
    .edit-icon {
      background-color: ${black};
      width: ${topHeaderHeight}px;
      height: ${topHeaderHeight}px;
      color: ${white};

      &:hover {
        background-color: ${warning};
      }
    }
  `;

  const params = useLecturePageParams();
  const { $state, CurrentPermissionsManager } = useContext(AngularServicesContext);
  const { isEditOrReorderMode } = useCourseHomeUtils();

  const showEditIcon = $state.current.parent === 'lecture-page-parent'
    && (
      CurrentPermissionsManager.isInstructor()
      || CurrentPermissionsManager.isCourseBuilder()
      || CurrentPermissionsManager.isConfigAndRegistrationRole()
    );

  const handleEditClick = () => {
    const { catalogId, lecturePageId } = params;

    const newPath = linkTolecturePage({
      catalogId,
      lecturePageId,
      mode: LecturePageMode.EDIT,
    });

    window.location.hash = `!/courses${newPath}`;
  };

  return (
    <React.Fragment>
      {showEditIcon && (
        <div css={styles} className='ml-2'>
          <TopPanelActionButton
            icon='edit'
            tooltipText={CurrentPermissionsManager.isCourseBuilder()
              ? t.INSTITUTIONS.CONTENT_LIBRARY.COLLECTIONS_HOME.LECTURE_LIST.LESSON_ACTION.EDIT_LESSON()
              : t.LECTURE_PAGES.ADMIN.EDIT_MENU_TOP_HEADER.ENTER_ADMIN_MODE()}
            useDefaultStyle={false}
            className='edit-icon'
            tooltipPlacement='bottom-end'
            ariaLabel={CurrentPermissionsManager.isCourseBuilder()
              ? t.INSTITUTIONS.CONTENT_LIBRARY.COLLECTIONS_HOME.LECTURE_LIST.LESSON_ACTION.EDIT_LESSON()
              : t.LECTURE_PAGES.ADMIN.EDIT_MENU_TOP_HEADER.ENTER_ADMIN_MODE()}
            dataQa={config.pendo.lectureEdit.editMenuTopPanel.editLessonOption}
            onClick={handleEditClick}
            isFocusable={!isEditOrReorderMode}
          />
        </div>
      )}
    </React.Fragment>
  );
};

export default LecturePageEditButton;
